module.exports = __webpack_public_path__ + "media/images/new/icons/santa0-cabd3fb0655559c6d1da8cb7004fb2d9.png";